import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, empty } from 'rxjs';
import {
  AddressType, ICustomer, ICustomerArchiveAddress, IChangeCustomerBody, ChangeCustomer, ICustomerSuggestion,
  Multiplier, IMultiplierPlan, AccountSummary, ICustomerAddress, Customer, BaseResponse
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { UserService } from './user.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  

  constructor(private httpClient: HttpClient
    , private userService: UserService) {

    this.currentCustomerNumber = userService.readUserObject.customerNumber;
  }
  currentCustomerNumber:string = '3031';//make customerid as number
  //#region CustomerAddress Api endPoints
  public getAllAddressList(): Observable<Array<ICustomer>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_ADDRESS}/${this.userService.readUserObject.customerNumber}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getAllCustomers(): Observable<Array<ICustomerSuggestion>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_ALLCUSTOMERS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, {}).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  
  public getSuggestion(searchString: string): Observable<Array<ICustomerSuggestion>> {
    const body = {
      searchString: searchString,
      userName: this.userService.readUserObject.userName
    }
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_SUGGESTION}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public addShippingAddress(customer: ICustomer): Observable<any> {
    customer.parentCustomerNumber = +this.userService.readUserObject.customerNumber;;
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.ADD_SHIPPING_ADDRESS}`;
    const data =  customer ;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public archiveAddress(customerArchiveAddress: ICustomerArchiveAddress): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.ARCHIVE_ADDRESS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, customerArchiveAddress).pipe(
      map((response: BaseResponse) => response.data),
      catchError((err) => {
        console.log(err);
        throw err;  // ✅ IMPORTANT – let component handle 400
      })
    );
  }
  public isDefaultAddress(address: ICustomerArchiveAddress): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.IS_DEFAULT_ADDRESS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, address).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  //#endregion
  //#region Business methods
  public getShippingAddress(customerNumber) {
    return this.addressList.find(r => (r.billingType === AddressType.Shipping) && r.customerNumber == customerNumber);
  }
  public getBillingAddress(customerNumber) {
    return this.addressList.find(r => (r.billingType === AddressType.Both || r.billingType==AddressType.Billing) 
    && r.customerNumber==customerNumber);
  }
  //#endregion

  //#region CUSTOMER ADDRESS CACHE & Operation
  private ADDRESS_LIST$: BehaviorSubject<ICustomer[]> = new BehaviorSubject<ICustomer[]>([]);
  private ADDRESS_LIST: ICustomer[] = [];
  public get addressList$(): BehaviorSubject<ICustomer[]> {
    if (!this.ADDRESS_LIST) {
      this.addressList = [] as ICustomer[];
    } else if (this.ADDRESS_LIST.length < 1) {
      this.addressList = [] as ICustomer[];
    }
    return this.ADDRESS_LIST$;
  }
  public get getAddressList(): ICustomer[] {
    if(!this.ADDRESS_LIST){
      this.ADDRESS_LIST=[];
    }
    return this.ADDRESS_LIST as ICustomer[];
  }
  public addAddressToList(customer:ICustomer){
    this.ADDRESS_LIST.push(customer);
    this.ADDRESS_LIST$.next(this.ADDRESS_LIST as ICustomer[]);
  }
  public archiveUnarchiveAddressToList(customerArchiveAddress: ICustomerArchiveAddress){

    let customeraddress=this.ADDRESS_LIST.find(r=>r.customerNumber===customerArchiveAddress.customerNumber);
    if(customeraddress){
      customeraddress.isActive=customerArchiveAddress.isActive;
    }
    this.ADDRESS_LIST$.next(this.ADDRESS_LIST as ICustomer[]);
  }
  public updateIsDefaultAddressLocal(dataItem: any) {
    dataItem.isSelected = true;
    this.getAddressList.filter(r => r.customerNumber !== dataItem.customerNumber).forEach((item, index) => {
      item.isDefault = false;
      item.isSelected = false;
    });
    //this.checkOutProcessModel.currentShipping.isSelected = false;
    //this.checkOutProcessModel.currentShipping = dataItem;
    //this.checkOutProcessModel.shipToCustomerNumber = dataItem.customerNumber;
  }
  public set addressList(addresslist: ICustomer[]) {
    const defaultShippingAddressNumber = this.userService.readUserObject.defaultShippingAddressNumber;
    if (defaultShippingAddressNumber != null && defaultShippingAddressNumber !== 0) {
      const index = addresslist.findIndex((ind => ind.customerNumber == defaultShippingAddressNumber));
      if (index >= 0)
        addresslist[index].isDefault = true;
    }
    this.ADDRESS_LIST = addresslist as ICustomer[];
    this.ADDRESS_LIST$.next(addresslist as ICustomer[]);
  }
  //#endregion
  //#region Change Customer
  public searchCustomer: ChangeCustomer = new ChangeCustomer();
  // public getCustomerSuggestions(body: IChangeCustomerBody): Observable<Array<ChangeCustomer>> {
  //   const endPoint = `${ConfigService.APIs.endPoints.CUSTOMER.CHANGE_ADDRESS}/${body.searchstring}`;
  //   return ApiService.genericObservableGet(this.httpClient, endPoint);
  // }
  //#endregion
  //#region customer multiplier
  public getMultiplierPlan(): Observable<IMultiplierPlan>{
    const data = {
      customerNumber: this.userService.readUserObject.customerNumber
    }
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_MULTIPLIER_PLAN}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  //#endregion


  public getAccountSummary(customerNumber: string): Observable<AccountSummary> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.ACCOUNT_SUMMARY}/${customerNumber}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }    )
      );
  }

 
 
}
